import axios from "axios";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://svb-system.onrender.com");

const toNumber = (value) => {
  if (value === undefined || value === null || value === "") return 0;

  const cleaned = String(value)
    .replace(/₹/g, "")
    .replace(/,/g, "")
    .replace(/%/g, "")
    .replace(/\s/g, "")
    .trim();

  return Number(cleaned) || 0;
};

export const fetchQuoteMasterItems = async () => {
  const res = await axios.get(`${BASE_URL}/api/quote-master`);

  return res.data.map((item) => {
    const mrp = toNumber(item.MRP || item.mrp || item.price);

    return {
      ...item,
      MRP: mrp,
      price: mrp,
    };
  });
};